import { Injectable } from '@angular/core';
import { ethers } from 'ethers';
import { environment } from '../../../environments/environment';
import { IProviderFactoryService } from './IProviderFactoryService';

export interface IStoreProvider {
    chainId: number;
    EVMProvider: ethers.FallbackProvider;
}

@Injectable({
    providedIn: 'root',
})
export class EVMProviderFactoryService implements IProviderFactoryService {
    protected EVMProviders: IStoreProvider[] = [];

    constructor() {}

    public getProvider(_chainId: number): ethers.Provider {
        _chainId = +_chainId;
        const findProvider = this.takeProvider(_chainId);

        if (findProvider !== undefined) {
            return findProvider;
        }

        if (!environment[_chainId]) {
            return;
        }
        const providersEVM = [];

        environment[_chainId].rpc.forEach((_url) => {
            providersEVM.push({
                provider: new ethers.JsonRpcProvider(_url, _chainId),
            });
        });

        const newProvidersEVM = new ethers.FallbackProvider(
            providersEVM,
            _chainId,
            { quorum: 1 }
        );

        this.EVMProviders.push({
            chainId: _chainId,
            EVMProvider: newProvidersEVM,
        });

        return newProvidersEVM;
    }

    private takeProvider(_chainId: number): ethers.Provider | undefined {
        if (this.EVMProviders && this.EVMProviders.length > 0) {
            const findProvider = this.EVMProviders.find(
                (v) => v.chainId === _chainId
            );

            if (findProvider != undefined) {
                return findProvider.EVMProvider;
            }
        }
        return undefined;
    }

    public async getApi(_platform: string) {}
}
